import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import InputGroup from '@/components/form/InputGroup.vue';
import TimeRangePicker from '@/components/form/TimeRangePicker.vue';
import SelectInput from '@/components/inputs/SelectInput.vue';
import { Icon } from '@/lib/enum/Icon';
import { dateInsideTimeRange } from '@/lib/forms/customValidators/shiftSessionsValidators';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { getErrorMessages, required } from '@/plugins/vuelidate';
import store from '@/store';
import { ShiftAreaSessionFormItemType } from '@/types/shiftSessionsForm';
import { viewport } from '@/util/windowFunctions';
import { useVuelidate } from '@vuelidate/core';
import spacetime from 'spacetime';
import { computed, reactive, watch } from 'vue';
import { ShiftArea } from '../../../api/v1';

/* PROPS */

export default /*#__PURE__*/_defineComponent({
  __name: 'AreaSessionFormItem',
  props: {
    date: null,
    shiftStartTime: null,
    shiftEndTime: null,
    shiftLocationId: { default: null },
    areaSession: null,
    showDelete: { type: Boolean, default: true }
  },
  emits: ["input", "removeArea"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: ShiftAreaSessionFormItemType): void;
  (e: 'removeArea', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { date: Date, shiftStartTime: string, shiftEndTime: string, shiftLocationId: number | null, areaSession: ShiftAreaSessionFormItemType, showDelete: boolean }



/* EMITS */


/* DATA */
const timezone = computed<string>(() => store.getters.timezone);
const anchorDate = computed<Date>(() => {
  if (props.shiftStartTime) {
    return spacetime(props.date, timezone.value)
      .time(props.shiftStartTime)
      .toNativeDate();
  }
  return spacetime(props.date, timezone.value).startOf('day').toNativeDate();
});

const activeShiftAreas = realtimeQuery(Entity.ShiftArea).whereActive().fetch();
const filteredShiftAreasForLocation = computed<ShiftArea>(() => {
  if (!props.shiftLocationId) {
    return activeShiftAreas.data;
  }
  return activeShiftAreas.data.filter((a) =>
    a.locationIds.includes(props.shiftLocationId),
  );
});

const form = reactive<ShiftAreaSessionFormItemType>({ ...props.areaSession });

const validations = computed(() => {
  const minStartDate = props.shiftStartTime
    ? spacetime(props.date, timezone.value).time(props.shiftStartTime)
    : null;
  let minEndDate = props.shiftEndTime
    ? spacetime(props.date, timezone.value).time(props.shiftEndTime)
    : null;
  if (minStartDate && minEndDate && minStartDate.isAfter(minEndDate)) {
    minEndDate = minEndDate.add(1, 'day');
  }

  return {
    shiftAreaId: {
      required,
    },
    startTime: {
      required,
      areaInsideShiftTimeRange: dateInsideTimeRange(
        () => minStartDate?.toNativeDate() || null,
        () => minEndDate?.toNativeDate() || null,
      ),
    },
    endTime: {
      required,
      areaInsideShiftTimeRange: dateInsideTimeRange(
        () => minStartDate?.toNativeDate() || null,
        () => minEndDate?.toNativeDate() || null,
      ),
    },
  };
});

const v$ = useVuelidate(validations, form, { $autoDirty: true });

/* WATCH */
watch(form, (v) => {
  emit('input', v);
});
watch(
  () => props.shiftLocationId,
  () => {
    if (
      !filteredShiftAreasForLocation.value.some(
        (a) => a.id === form.shiftAreaId,
      )
    ) {
      form.shiftAreaId = null;
      v$.value.$touch();
    }
  },
);

return { __sfc: true,props, emit, timezone, anchorDate, activeShiftAreas, filteredShiftAreasForLocation, form, validations, v$, Button, InputGroup, TimeRangePicker, SelectInput, Icon, getErrorMessages, viewport }
}

})